import { useContext } from 'react';
import { IdentifierContext } from '../context';

export function useIdentifiers() {
    const context = useContext(IdentifierContext);
    return { ...context };
}
